module.exports = __webpack_public_path__ + "img/crowdfunding.c53f4023.png";